import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Body, MenuPath, SectionDivider, Warning } from '../ui';
import loadingTouchFileVideo from '../../../assets/video/loading-touchfile.mp4';
import VideoPlayer from './VideoPlayer';

const LoadingTouchFileDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      <h2
        id="loading-touch-files"
        className="font-display text-[24px] font-extrabold text-content-primary mb-[24px] tracking-[-0.4px]"
      >
        {t('docs.loadingTouchFile.title')}
      </h2>
      <VideoPlayer src={loadingTouchFileVideo} />

      <Body>
        <Trans
          i18nKey="docs.loadingTouchFile.intro"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <h3 className="font-display text-[17px] font-bold text-content-primary mt-[24px] mb-[10px]">
        {t('docs.loadingTouchFile.openingFromEditorTitle')}
      </h3>
      <ol className="p-0 mb-[8px] list-none">
        {(
          [
            <Trans
              i18nKey="docs.loadingTouchFile.openingStep1"
              components={{ code: <MenuPath>{''}</MenuPath> }}
            />,
            <Trans
              i18nKey="docs.loadingTouchFile.openingStep2"
              components={{ code: <MenuPath>{''}</MenuPath> }}
            />,
            <>{t('docs.loadingTouchFile.openingStep3')}</>,
          ] as React.ReactNode[]
        ).map((step, i) => (
          <li key={i} className="flex gap-[16px] mb-[16px] items-start">
            <span className="shrink-0 w-[28px] h-[28px] rounded-full bg-surface-hover border-[1.5px] border-border-brand flex items-center justify-center font-display text-[13px] font-bold text-blue-link">
              {i + 1}
            </span>
            <p className="mt-[4px] text-[14px] leading-[1.75] text-content-secondary">
              {step}
            </p>
          </li>
        ))}
      </ol>

      <SectionDivider />

      <h3 className="font-display text-[17px] font-bold text-content-primary mb-[10px]">
        {t('docs.loadingTouchFile.dragDropTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.loadingTouchFile.dragDropBody"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.loadingTouchFile.dragDropNote"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <Warning label={t('docs.loadingTouchFile.warningLabel')}>
        {t('docs.loadingTouchFile.replaceWarning')}
      </Warning>
    </article>
  );
};

export default LoadingTouchFileDoc;
